<div class="content">
  <div class="item" (click)="activeZone('#all$')" [ngClass]="{ active: isZone('#all$') }">All Zones</div>
  <div class="item" *ngFor="let item of data.zones" (click)="activeZone(item)" [ngClass]="{ active: isZone(item.slug) }">
    {{ item.name }}
  </div>
</div>
